import { Component, HostBinding, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IsTouchOnlyEnvironment } from '../../../helper/mobile';
import { resolveAstralIconClass } from '../astral-icon-class.util';

@Component({
  selector: 'astral-popover',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <button
      type="button"
      class="astral-popover__trigger"
      [attr.popovertarget]="helpPopoverId"
      popoverTargetAction="toggle"
      [attr.aria-controls]="helpPopoverId"
      [attr.title]="triggerLabelKey | translate"
      [attr.aria-label]="triggerLabelKey | translate"
    >
      <i class="astral-popover__trigger-icon" [class]="'astral-popover__trigger-icon ' + triggerIconClass" aria-hidden="true"></i>
    </button>

    <div class="astral-popover__help-popover" [attr.id]="helpPopoverId" popover="auto">
      {{ helpText | translate }}
    </div>
  `,
  styleUrls: ['./astral-popover.component.scss'],
})
export class AstralPopoverComponent {
  private static nextId = 0;
  private readonly uid = `astral-popover-${++AstralPopoverComponent.nextId}`;

  @Input() helpText: string;
  @Input() contentId: string;
  @Input() inline = false;

  @HostBinding('class.astral-popover--inline')
  get inlineClass(): boolean {
    return this.inline;
  }

  get helpPopoverId(): string {
    return this.contentId ?? `${this.uid}-content`;
  }

  get triggerIconClass(): string {
    return resolveAstralIconClass('question') ?? '';
  }

  get triggerLabelKey(): string {
    return IsTouchOnlyEnvironment() ? 'COMMON.TAP_FOR_HELP_TEXT' : 'COMMON.CLICK_FOR_HELP_TEXT';
  }
}
